import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Tooltip } from "react-tooltip";

import "react-toastify/dist/ReactToastify.css";
import "react-tooltip/dist/react-tooltip.css";
import "animate.css";
import "./styles/main.scss";

import { getRoutes } from "./Router";
import reportWebVitals from "./reportWebVitals";
import Contexts from './Contexts'

const router = createBrowserRouter(getRoutes());

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Contexts>
    <RouterProvider router={router} />
    <ToastContainer position="top-right" theme="colored" />
    <Tooltip id="tooltip" />
  </Contexts>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
